import {jsonRoute} from '@github-ui/react-core/json-route'
import {registerReactAppFactory} from '@github-ui/react-core/register-app'

import {App} from './App'

import {BoomTown} from './routes/BoomTown'
import {CopilotIndex} from './routes/CopilotIndex'
import {DiversityIndex} from './routes/DiversityIndex'
import {EnterpriseIndex} from './routes/EnterpriseIndex'
import {SecurityIndex} from './routes/SecurityIndex'
import {ShowPage} from './routes/ShowPage'
import {CopilotPlansIndex} from './routes/copilot/PlansIndex'

registerReactAppFactory('landing-pages', () => ({
  App,
  routes: [
    jsonRoute({path: '/about/diversity', Component: DiversityIndex}),
    jsonRoute({path: '/features/copilot', Component: CopilotIndex}),
    jsonRoute({path: '/features/copilot/plans', Component: CopilotPlansIndex}),
    jsonRoute({path: '/features/security', Component: SecurityIndex}),
    jsonRoute({path: '/enterprise', Component: EnterpriseIndex}),

    /**
     * We use this route to exercise error handling and exception reporting.
     * in the app. The BoomTown component simply throws an error when it renders.
     */
    jsonRoute({path: '/contentful-lp-tests/boomtown', Component: BoomTown}),

    jsonRoute({path: '*', Component: ShowPage}),
  ],
}))
